import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PointModel} from "../models/point.model";

@Component({
  selector: 'point-details',
  templateUrl: './point-details.component.html',
  styleUrls: ['./point-details.component.scss']
})
export class PointDetailsComponent implements OnInit, OnChanges {

  @Input() currentCoordinates: PointModel;
  @Input() selectedPoint: PointModel;
  @Output() selectedPointChange: EventEmitter<PointModel> = new EventEmitter<PointModel>();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedPoint) {

    }
  }

  public clearSelectedPoint(){
    this.selectedPointChange.emit(null);
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/point-details/point-details.component.ts